import React, { Component } from 'react';

export default class ValidationRequired extends Component {
  render() {
    return <b className="validation-required">*</b>;
  }
}
